export interface BottomNavIconConfig {
  id: string;
  name: string;
  iconPath: string;
  requiresLogin?: boolean;
  redirectUrl?: string;
}

export enum BottomNavIconsEnum {
    Games = 'games',
    Search = 'search',
    Rewards = 'rewards',
    Menu = 'menu'
}
